<template lang="pug">
#processSetting
  set(ref="set" source="lowcode" v-if="showPage==='set'" @updateTree="updateTree" @openDesigner="openDesigner")
  flowEditor(ref="flowEditor" source="lowcode" v-if="showPage==='designer'" :viewMode="viewMode" @updateTree="updateTree" @closeDesigner="close")
</template>

<script>
import set from "@/CommonDP/components/processComponents/components/setLowCode.vue";
import flowEditor from "@/CommonDP/components/processComponents/components/flowEditor.vue";
import { setGroupName, setFormList } from "@/CommonDP/components/processComponents/config";
import metadataService from "@/CommonDP/service/metadata-service.js";

export default {
  components: { set, flowEditor },
  data () {
    return {
      viewMode: 0, // 新增0 编辑1 查看2
      showPage: '', // 展示哪个页面
      parentId: "",
      groupId: ""
    };
  },
  inject: ["metaSideNode"],
  computed: {

  },
  mounted () {
  },
  methods: {
    async setParentNode(data) {
      const node = this.metaSideNode();
      setGroupName({ id: data.groupId, name: node.parent.data.groupName + '-业务流程' });
      const formlist = await this.formList();
      setFormList(formlist);
      this.groupId = data.groupId;
      this.parentId = data.parentId;
      this.showPage = "set";
    },
    async formList() {
      let node = this.metaSideNode();
      while (node.level > 2) node = node.parent;
      const data = node.childNodes.find((e) => e.label === "表单页面").data;
      const groupId = data.groupId;
      const templateType = data.templateType;
      return this.getChildNodeDataList(groupId, templateType);
    },
    async getChildNodeDataList(groupId, templateType) {
      const { data } = await metadataService.getChildNodeDataList(groupId, templateType);
      return data || [];
    },
    openDesigner(val) {
      // this.$emit('initTree');
      this.viewMode = val || 0;
      this.showPage = "designer";
    },
    async close(boolean) {
      this.showPage = "set";
      this.$emit("initTree");
      await this.$nextTick();
      boolean && this.$refs.set.updateNodes();
    },
    updateTree() {
      this.$emit("initTree");
    },
    update() {

    },
    dealNode(tree) {
      for (const iterator of tree) {
        if (this.parentId === iterator.groupId) {
          const paramsObj = {
            name: iterator.groupName + '-业务流程',
            id: this.groupId
          };
          setGroupName(paramsObj);
        }
        if (this.parentId === iterator.parentId && iterator.groupName === "表单页面") {
          setFormList(iterator.children || []);
        }
        if (iterator.children && iterator.children.length > 0) {
          this.dealNode(iterator.children);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#processSetting {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
